<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <span class="weui-form-preview__value">{{params.custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">年度</label>
            <span class="weui-form-preview__value">{{params.year}}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview" v-for="(item, index) in result" :key="index">
        <div class="form-detail-preview_num">{{index + 1}}</div>
        <div class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">月份</label>
            <span class="weui-form-preview__value">{{item.cm_yearmonth}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{item.cm_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月应收金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cm_year_rec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">当前应收余额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cm_end}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月已收金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cm_received}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月未收金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cm_add_rec_remain_nb}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月出货金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cm_add_rec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月已对账金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.sbm_now_amount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月未对账金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cm_add_rec - item.sbm_now_amount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月客户入库金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vm_pay}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月预收余额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cm_end_pre}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月已核金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.cm_reduce_rec}}</span>
          </div>
          
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">对账状态</label>
            <span class="weui-form-preview__value">{{item.sbm_bill_status}}</span>
          </div>
          <!-- <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">对账明细表</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              <span class="iconfont icon-eye" @click="onToSaleArcheck(index)"></span>
            </span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(!to.params.item)to.params.item = from.params.item || null // 兼容返回到本页
      vm.params.custid = to.params.item.cy_custid
      vm.params.custname = to.params.item.cy_custname
      vm.params.year = to.params.item.cy_year
      vm.params.currency = to.params.item.cy_currency
      vm.requestList();
    });
  },
  data() {
    return {
      listUrl: "/api/sale/saleBill/listByMonth",
      params: {
        custid: null,
        custname: "",
        year: null,
        currency: "",
        billStatus: "",
        page: 1,
        start: 0,
        limit: 25,        
      },
      result: []
    };
  },
  methods: {
    requestList() {
      var me = this
      me.$loading({
          url: me.listUrl,
          params: me.params
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    cm_endamount(index) {
      return this.result[index].cm_nowamount - this.result[index].cm_nowprepayamount - this.result[index].cm_nowpayamount
    },
    // onToSaleArcheck(index) {
    //   let form = this.result[index]

    //   let item = {
    //     currency: form.cm_currency,
    //     custname: this.params.custname,
    //     custid: this.params.custid,
    //     year: form.cm_year,
    //     yearmonth: form.cm_yearmonth,
    //   }

    //   this.$router.push({
    //     name: 'SaleArcheck',
    //     params: {
    //       item
    //     }
    //   })
    // }
  }
}
</script>